import { ICardNameState } from './types';

const initialCardName: ICardNameState = {
    renameCardId: null
};

export const getInitialCardName = (): ICardNameState => {
    return {...initialCardName};
};
